import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { apiConnector } from '@/integrations/api.connector';
import { getUserToken } from '@/services/user-hash';
import { useAppDispatch, useAppSelector } from '@/store';
import { tokenValidate } from '@/store/auth.slice';
import { getUserAccount } from '@/store/userInfo.slice';

import { ROUTES } from './routes';

const UNAUTHORIZED_ROUTES = ['/login', '/reset_password', '/approvements'];

interface IProps {
  AuthModal: React.ReactNode;
}

const CheckAuth: React.FC<IProps> = ({ AuthModal }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isUserAuth } = useAppSelector((state) => state.auth);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(tokenValidate()).then(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    const accessToken = getUserToken().accessToken;
    if (!isUserAuth) {
      const shouldRedirect = UNAUTHORIZED_ROUTES.find((item) =>
        location.pathname.includes(item)
      );
      if (!shouldRedirect) {
        const savedUrl =
          location.pathname !== ROUTES.login &&
          !location.pathname.includes('create')
            ? `${location.pathname}${location.search}`
            : '';
        navigate(ROUTES.login, { state: { savedUrl } });
      }
    } else if (isUserAuth && accessToken) dispatch(getUserAccount());
  }, [isUserAuth]);

  useEffect(() => {
    // Выделяем время на прогрузку страницы
    const timeout = setTimeout(() => {
      if (isUserAuth) apiConnector.timeForCheck();
    }, 200);
    return () => {
      clearTimeout(timeout);
    };
  }, [location.pathname]);

  return (
    <>
      {!isLoading && <Outlet />}
      {AuthModal}
    </>
  );
};

export default CheckAuth;
